import './App.css';
import Navbar from './components/Navbar';
import WorthBox from './components/WorthBox';

function App() {
  return (
    <div className="App">
      <Navbar />
      <WorthBox />
    </div>
  );
}

export default App;
